import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */
export default () => {
  function init() {
    const target = '#search-collection';
    new Swiper(target, {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 5,
          centeredSlides: false,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        440: {
          slidesPerView: 2,
          spaceBetween: 5,
          centeredSlides: false,
        },
        790: {
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          centeredSlides: false,
        },
      },
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
